import { getShowAccessPassPopup } from "basket_and_checkout/shared/components/PDP/Pricing/utils"
import { getUser } from "lib/user"
import { useUSJourney } from "packages/acquisition/hooks/useUSJourney"
import { useEffect, useState } from "react"

export const useTypicalJourney = (): boolean => {
  const hasDismissedPDPPopup = !!getShowAccessPassPopup()
  const isUsJourney = useUSJourney()
  const user = getUser()
  const [typicalJourney, setTypicalJourney] = useState(false)
  const isTypicalJourney =
    (hasDismissedPDPPopup && !user?.hasMembership) ||
    (isUsJourney && !user?.hasMembership)

  useEffect(() => {
    setTypicalJourney(isTypicalJourney)
  }, [isTypicalJourney])

  return typicalJourney
}
